import { render } from "./CIS-Resource-Blog.vue?vue&type=template&id=4f276a1e&scoped=true"
import script from "./CIS-Resource-Blog.vue?vue&type=script&lang=js"
export * from "./CIS-Resource-Blog.vue?vue&type=script&lang=js"

import "./CIS-Resource-Blog.vue?vue&type=style&index=0&id=4f276a1e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f276a1e"]])

export default __exports__